import axios from 'axios'
import { Notify, Toast } from 'vant'

// import {getHeaders, getToken, setCookies} from '@/utils/utils'
// const baseURL = window.context.BASE_URL 
const baseURL = '/api' 
//创建axios的一个实例
var instance = axios.create({
  baseURL: baseURL, // api的base_url
  timeout: 65 * 1000 // request timeout                                                    //设置超时
})


//------------------- 一、请求拦截器 忽略
instance.interceptors.request.use(function (config) {
  config.headers = config.headers || {}
  const userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
  userInfo && userInfo.token && !config.headers.Authorization && (config.headers.Authorization = `Bearer ${userInfo.token}`)
  // console.log('userInfo',userInfo);
  // console.log('config',config);
  // //如果是请求auth接口，则不带token
  // if (config.url.indexOf('/auth?') != -1 || config.url.indexOf('/getTenantByCode?') != -1) {
  //   delete config.headers.Authorization
  // }
  
  if (!config.hideLoading) {
    Toast.loading({
      message: config.loadingText || '加载中...',
      forbidClick: true,
      duration: 0,
    });
  }
  return config;
}, function (error) {
  // 对请求错误做些什么

  return Promise.reject(error);
});

//----------------- 二、响应拦截器 忽略
instance.interceptors.response.use(function (response) {
  // const res = response.data
  // if (res.status&&res.status == '00') {
  //   // 成功
  //      cb(res)
  //  }else{
  //          // 失败
  //       Notify({ type: 'warning', message: res.header.msg });
  //   }

  Toast.clear()

  return response.data;
}, function (error) {
  Toast.clear()
  Notify({ type: 'warning', message: '服务器未响应，请稍后重试'});
  // 对响应错误做点什么
  return Promise.reject(error);
});

/**
 * 使用es6的export default导出了一个函数，导出的函数代替axios去帮我们请求数据，
 * 函数的参数及返回值如下：
 * @param {String} method  请求的方法：get、post、delete、put
 * @param {String} url     请求的url:
 * @param {Object} data    请求的参数
 * @returns {Promise}     返回一个promise对象，其实就相当于axios请求数据的返回值
 */
export default {
  request(data) {
    
    let reqData = data.data || {}
    //统一拼接域名接口
    // if (data.url.indexOf('http') == -1) {
    //   data.url = baseURL + data.url
    // }
    let requestData = {
      url: data.url,
      data: reqData,
      method: data.method || 'GET',
      params: data.params || {},
      changeOrigin:true,
      onUploadProgress: data.onUploadProgress || null,
      // headers['Content-Type']: 'application/x-www-form-urlencoded;charset=UTF-8';  //此处是增加的代码，设置请求头的类型
      headers: data.headers || '',
      hideLoading: data.hideLoading || false,
      
      responseType: data.responseType || 'json'

    }
    return instance(requestData)
  },
  // 请求下载文件流时responseType传blob
  get({url, params, type}) {
    return this.request({url, params, responseType: type, })
  },
  post({url, data, responseType,hideLoading}) {
    
    return this.request({url, data, responseType: responseType,hideLoading: hideLoading,  method: 'POST'})
  },
  remove(url) {
    return this.request({url, method: 'DELETE'})
  },
  put(url) {
    return this.request({url, method: 'PUT'})
  },
  putObj(url, data, responseType) {
    return this.request({url, data, method: 'PUT', responseType: responseType})
  }
}

